module.exports = __webpack_public_path__ + "img/iPhone-travel.4ddffba3.webp";